import classNames from 'classnames';
import React, { PropTypes } from 'react';

function HelpButton({ type, theme }) {
  return (
    <button
      className={
        classNames(
          'c-kd-select-geography__help-button',
          theme['c-kd-select-geography__help-button'],
        )
      }
      onClick={event => event.preventDefault}
      title={type}
    />
  );
}

HelpButton.propTypes = {
  theme: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
  ]).isRequired,
  type: PropTypes.string.isRequired,
};

export default HelpButton;



// WEBPACK FOOTER //
// ./app/components/KdSelectGeography/HelpButton.js